// Bug-1 hotfix wrapper. @os/mail's MailFolderSidebar pins its own
// rail width (currently w-[256px]). Other workspaces' secondary rails
// are 360px (AppLayout's secondarySidebar slot — used by Calendar,
// Tasks, etc). MailDashboard mounts the sidebar inline (bypassing the
// slot), so AppLayout's wrapper width doesn't apply and the rail
// reads visibly narrower than its peers.
//
// We wrap the upstream component in a 360px container and force the
// inner root element (a <div> in 1.13.x) to fill via
// `[&>div]:!w-full`. The !important defeats the inner's own w-[256px]
// without forking the package.
//
// Drop this wrapper when @os/mail exposes a widthClass / className
// prop on the sidebar root (TECH-DEBT-2 in the plan). Path B in the
// A/B split — Path A is an upstream MR.
//
// Refs: docs/superpowers/plans/2026-05-18-mail-ui-hotfix.md Task 1
import type { ComponentProps } from 'react'
import MailFolderSidebar from '@os/mail/web/components/MailFolderSidebar'

type Props = ComponentProps<typeof MailFolderSidebar>

export default function MailFolderSidebarWrapper(props: Props) {
  // W1.3: on mobile this wrapper lands in the shell's L2 nav drawer (a flex-1
  // slot ~248px wide) — fill it instead of overflowing at a fixed 360px.
  // Desktop keeps the 360px inline rail. `[&>div]:!w-full` still forces the
  // inner sidebar (its own w-[256px]) to fill the wrapper at either size.
  return (
    <div className="w-full lg:w-[360px] shrink-0 flex [&>div]:!w-full">
      <MailFolderSidebar {...props} />
    </div>
  )
}
